import React from 'react';

import SoccerLineup from '../../soccer/Lineup';
import VolleyBallLineup from '../../volleyball/Lineup';
import HockeyLineup from '../../hockey/Lineup';
import FootballLineup from '../../hockey/Lineup';
import BasketballLineup from '../../basketball/BasketBallLineup';
import BaseballLineup from '../../baseball/Lineup';

const LineUpWrapper = ({ sportsType }) => {
  let renderComponent = null;
  switch (sportsType) {
    case 'baseball':
      renderComponent = <BaseballLineup />;
      break;
    case 'basketball':
      renderComponent = <BasketballLineup />;
      break;
    case 'soccer':
      renderComponent = <SoccerLineup />;
      break;
    case 'volleyball':
      renderComponent = <VolleyBallLineup />;
      break;
    case 'hockey':
      renderComponent = <HockeyLineup />;
      break;
    case 'football':
      renderComponent = <FootballLineup />;
      break;
  }
  return <div>{renderComponent}</div>;
};

export default LineUpWrapper;
